// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"212190fc","453":"31bf9d75","455":"6516be2b"}[chunkId] + ".chunk.js";
};